/** Full-course narration (per-sentence TTS + WhisperX) often exceeds 5 minutes. */
export const SCRIPT_AUDIO_ALIGN_PROCESS_TIMEOUT_MS = 60 * 60_000;

/** Course explain visual-plan mapping + preview build can run several minutes. */
export const SCRIPT_AUDIO_ALIGN_PREVIEW_TIMEOUT_MS = 30 * 60_000;

/** Curriculum planning LLM pass. */
export const SCRIPT_AUDIO_ALIGN_COURSE_PLAN_TIMEOUT_MS = 30 * 60_000;

/** Poll after browser timeout while the server finishes alignment. */
export const SCRIPT_AUDIO_ALIGN_RECOVERY_POLL_MS = 15 * 60_000;

export const SCRIPT_AUDIO_ALIGN_RECOVERY_INTERVAL_MS = 5_000;

export function isRequestTimeout(err) {
  return err?.code === 'ECONNABORTED' || /timeout/i.test(String(err?.message || ''));
}
